/**
 * Created by Ning Jiang on 11/22/2016.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BookOfShadowsGameModuleConfig} from "./BookOfShadowsGameModuleConfig";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BookOfShadowsGameConfig} from "./BookOfShadowsGameConfig";
import {BetBoostData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetHandler";
import {ILockedReelDetailItems} from "./reelLock/BookOfShadowsReelLockController";
import {ILockedReelsDetails} from "./server/data/IBookOfShadowsServerData";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {KeypadPluginEvents, KeypadPluginUserBetUpdateData} from "@nolimitcity/slot-launcher/bin/plugins/KeypadPlugin";
import {BookOfShadowsWinFieldController} from "./gameround/BookOfShadowsWinFieldController";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BookOfShadowsParsedInitData} from "./server/data/BookOfShadowsParsedInitData";
import {BookOfShadowsPromoPanelConfig} from "./BookOfShadowsPromoPanelConfig";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

require("gsap");

export class BookOfShadows extends SlotGame {
    public static timelineReelsController: TimelineReelsController;
    private static gameRoundManager: GameRoundManager;
    private _activeRowsAllowedJurisdiction: boolean = true;
    private _luckyLocksAllowedJurisdiction: boolean = true;
    private _okButtonClicked: boolean = false;
    private _restoreData:{openRows:number} | undefined;
    private skinner:Skinner;
    private paytable:string = <string>require("../../nolimit/screens/paytable.mustache");

    /**
     * @constructs
     */
    constructor() {
        super(BookOfShadowsGameModuleConfig.instance);
        const validSkins:string[] = [
            "us-nonfree" //gameClientConfiguration.replaceWordFree
        ]
        this.skinner = new Skinner(validSkins);
    }

    /**
     * @description To set the boosted bet in the keypad.
     */
    public static setBoostedBet(): void {
        let boostData: BetBoostData | undefined = undefined;
        const rows: string = (BookOfShadowsGameConfig.instance.ACTIVE_ROWS + "");

        // #331
        BookOfShadowsGameConfig.instance.TOTAL_COST = 0;

        if (this.hasLockedReel()) {
            //Todo - There needs to be handling of when you are allowed to lock reels, and so on.

            const featureName: string = `BOOSTED_BET_LOCKED_REELS`,
                featureData = BookOfShadows.getLockedReelData(rows);

            if (featureData !== undefined) {
                boostData = {
                    featureName: featureName,
                    price: featureData.price,
                    isPreCalculatedPrice: true,
                    playerInteraction: {
                        baseRows: rows,
                        lockedReel: featureData.setup,
                        price: featureData.price
                    }
                };

                // #331
                BookOfShadowsGameConfig.instance.TOTAL_COST = featureData.price;
            }
        } else {
/*            const featureName: string = `BOOSTED_BET_${rows}_ROWS`,
                featureData = BookOfShadows.api.bonusFeatures.getFeatureDataByName(featureName);

            if (featureData !== undefined) {
                boostData = {
                    featureName: featureName,
                    price: featureData.price,
                    playerInteraction: {
                        baseRows: rows,
                        lockedReel: "0,0,0,0,0"
                    }
                };

                // #331
                const calculatedPrice: number = (featureData.price * parseFloat(BookOfShadows.api.betLevel.getLevel()));
                BookOfShadowsGameConfig.instance.TOTAL_COST = parseFloat(calculatedPrice.toFixed(2));
            }*/
        }

      //  BookOfShadows.api.betHandler.setBoost(boostData);
    }

    public onSelectedFeatureBetChanged() {
        const feature = BookOfShadows.api.betFeatureController.getActiveBetFeature();
        let cost:number = 0;
        let rows = 3;
        if (feature) {
            cost = feature.getTotalCost();
            //if (feature.type != "FREESPIN"){
                if (feature.name.indexOf("4") !== -1) {
                    rows = 4;
                } else if (feature.name.indexOf("5") !== -1) {
                    rows = 5;
                }
            //}
        }

        if (this._restoreData){
            rows = this._restoreData.openRows;
        }

        const rowsChanged = BookOfShadowsGameConfig.instance.ACTIVE_ROWS != rows;
        BookOfShadowsGameConfig.instance.ACTIVE_ROWS = rows;
        BookOfShadowsGameConfig.instance.TOTAL_COST = cost;
        BookOfShadowsGameModuleConfig.inactiveRowController.updateRowsOverlay(rowsChanged)

    }

    /**
     * @description Helper method to really transform the locked reel string array to string only.
     */
    public static calculateLockedReel(): string {
        let retVal: string = "";
        const lockedReel: string[] = BookOfShadowsGameConfig.instance.LOCKED_REEL;

        for (let i: number = 0; i < lockedReel.length; i++) {
            retVal = retVal.concat(lockedReel[i]);
            if (i !== (lockedReel.length - 1)) {
                retVal = retVal.concat(",");
            }
        }

        return retVal;
    }

    private static getLockedReelData(rows: string): ILockedReelsDetails {
        const lockedReel: string = BookOfShadows.calculateLockedReel(),
            details: ILockedReelDetailItems = BookOfShadowsGameModuleConfig.reelLockController.lockedReelDetails;

        return details[rows + "_" + lockedReel];
    }

    private static hasLockedReel(): boolean {
        return (BookOfShadowsGameConfig.instance.LOCKED_REEL.indexOf("1") > -1);
    }


    getReadyToStart():Promise<NolimitPlugin> {
        BookOfShadows.api.betHandler.addBetDataInjectCallback(BookOfShadowsPromoPanelConfig.injectActionSpinPlayerInteractionData);
        return super.getReadyToStart();
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((plugin: NolimitPlugin) => {
            if (BookOfShadows.api.gameClientConfiguration.isSet) {
                this.applyGameClientConfiguration();
            } else {
                BookOfShadows.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => this.applyGameClientConfiguration());
            }

            BookOfShadows.keypad.events.on(KeypadPluginEvents.USER_BET_UPDATE, (data: KeypadPluginUserBetUpdateData) => this.onUserBetUpdate(data));
            BookOfShadows.api.freeBets.events.on(BookOfShadows.api.freeBets.FREE_BETS_START, () => this.onFreeBets(true));
            BookOfShadows.api.freeBets.events.on(BookOfShadows.api.freeBets.FREE_BETS_END, () => this.onFreeBets(false));

            BookOfShadows.api.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, ()=>this.onSelectedFeatureBetChanged());

            BookOfShadows.api.events.once(APIEvent.BET, ()=>{
               delete this._restoreData;
            });


            //Making sure that skinID is set based  on "replaceWordFree" gcc.
            if (BookOfShadows.api.gameClientConfiguration.isSet){
                if (BookOfShadows.api.gameClientConfiguration.replaceWordFree){
                    this.skinner.skinId = "us-nonfree";
                }
            }
            else {
                BookOfShadows.api.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED,()=>{
                    if (BookOfShadows.api.gameClientConfiguration.replaceWordFree){
                        this.skinner.skinId = "us-nonfree";
                    }
                })
            }

            return plugin;
        });
    }


    public async getReady(): Promise<NolimitPlugin> {
        const value = await super.getReady();

        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();

            //intro
            for (let i=1; i <= 22; i++){
                const padded = ('00' + i).slice(-2);
                replaceMap.set(`resources/images/intro/Feature1/Feature1Reel/Feature1_000${padded}.png`, `Feature1Reel/Feature1_000${padded}.png`);
                console.log(padded)
            }

            //Bonus
            replaceMap.set("FREESPIN_3_ROWS", "FREESPIN_3_ROWS.png");
            replaceMap.set("FREESPIN_4_ROWS", "FREESPIN_4_ROWS.png");
            replaceMap.set("FREESPIN_5_ROWS", "FREESPIN_5_ROWS.png");

            await this.skinner.loadSkin(replaceMap);
        }

        return value;
    }



    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath:"screens/images/"
            };

            if (this.skinner.skinId != undefined){
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString:string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);

            resolve(paytableString);
        });
    }

    protected onInitDataParsed(data:BookOfShadowsParsedInitData) {
        super.onInitDataParsed(data);
        if (data.isRestoreState){
            this._restoreData = {
                openRows:data.selectedRowsFS
            }
        }

    }

    public getGameRules(): Promise<string> {
        return super.getGameRules().then(value => {
            const allFeatures: FeatureBuyTimesBetValue[] = (BookOfShadows.model.initData as BookOfShadowsParsedInitData).featureBuyTimesBetValue;
            let bonusWheelPrice: number | undefined;

            for (let i: number = 0; i < allFeatures.length; i++) {
                if (allFeatures[i].name === "FREESPIN_3_ROWS") {
                    bonusWheelPrice = allFeatures[i].price;
                    break;
                }
            }

            if (bonusWheelPrice === undefined) {
                BookOfShadows.api.warn("Can't find BONUS_WHEEL price");
                return value;
            }

            const data: any = {
                replaceSlotsInGameRules: BookOfShadows.api.gameClientConfiguration.replaceSlotsInGameRules,
                replaceWincapInfo: BookOfShadows.api.gameClientConfiguration.replaceWincapInfo,
                showBaseGameHighestWinInRules: BookOfShadows.api.gameClientConfiguration.showBaseGameHighestWinInRules
            };

            const nj: boolean = !!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1);
            let renderedData: string = BookOfShadows.api.translations.render(value, data);
            renderedData = renderedData.replace("#BONUS_WHEEL_PRICE", "" + bonusWheelPrice);
            renderedData = renderedData.replace(new RegExp("#isNJ", "g"), (nj ? "isNJServer" : ""));
            return renderedData;
        });
    }

    /**
     * @inheritDoc
     */
    protected initGame(): void {
        if (BookOfShadowsGameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            BookOfShadows.timelineReelsController = TimelineReelsController.instance;
            BookOfShadows.gameRoundManager = new GameRoundManager(BookOfShadowsGameModuleConfig.instance.GAME_ROUND_CONFIG());
        } else {
            super.initGame();
        }
    }

    protected createWinFieldController(): BookOfShadowsWinFieldController {
        return new BookOfShadowsWinFieldController();
    }

    private applyGameClientConfiguration(): void {
        if (!BookOfShadows.api.gameClientConfiguration.boostedBetLockedReels) {
            // turn off locked reels.
            BookOfShadows.resetBoostedBet();
            this._luckyLocksAllowedJurisdiction = false;
            BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_JURISDICTION = false;
        }
        if (!BookOfShadows.api.gameClientConfiguration.boostedBetExtraRows) {
            // turn off shadow rows.
            BookOfShadows.resetBoostedBet();
            this._activeRowsAllowedJurisdiction = false;
            BookOfShadowsGameConfig.instance.ACTIVE_ROWS_ALLOWED_JURISDICTION = false;
        }
    }

    /**
     * @description To reset boosted bet.
     */
    private static resetBoostedBet(): void {
        BookOfShadowsGameConfig.instance.ACTIVE_ROWS = 3;
        BookOfShadowsGameConfig.instance.LOCKED_REEL = ["0", "0", "0", "0", "0"];
        BookOfShadows.setBoostedBet();
    }

    private onUserBetUpdate(data: KeypadPluginUserBetUpdateData) {
        if (BookOfShadows.model.gameData) {
            // if feature is not allowed
            if (!BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_JURISDICTION) {
                return;
            }

            if (BookOfShadows.model.gameData.playedBetValue === parseFloat(data.from) && BookOfShadows.model.gameData.playedBetValue !== parseFloat(data.to)) {
                //Changing from valid lock reel bet to something else.

                // #320
                this._okButtonClicked = false;

                BookOfShadows.api.dialog.showGameDialog({
                    alwaysShow: true,
                    header: BookOfShadows.api.translations.translate("Changing bet will disable feature"),
                    message: BookOfShadows.api.translations.translate("Lucky Locks will be disabled if you proceed. Press OK to proceed or press CANCEL to return to previous bet."),
                    okButtonLabel: BookOfShadows.api.translations.translate("OK"),
                    cancelButtonLabel: BookOfShadows.api.translations.translate("CANCEL"),
                    onClose: () => {
                        // #320
                        if (!this._okButtonClicked && BookOfShadows.model.gameData.playedBetValue !== parseFloat(BookOfShadows.api.betLevel.getLevel())) {
                            BookOfShadows.api.betLevel.setLevel(data.from);
                        }
                    },
                    onOkClick: () => {
                        BookOfShadowsGameModuleConfig.reelLockController.exitedFS();
                        BookOfShadowsGameModuleConfig.reelLockController.toggleLockButtonsEnable(false);
                        BookOfShadows.setBoostedBet();

                        BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_VIA_BET = false;

                        // #320
                        this._okButtonClicked = true;
                    },
                    onCancelClick: () => {
                        BookOfShadows.api.betLevel.setLevel(data.from);
                    }
                });
            } else {
                if (BookOfShadows.model.gameData.playedBetValue === parseFloat(data.to) && BookOfShadows.model.gameData.playedBetValue !== parseFloat(data.from)) {
                    BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_VIA_BET = true;
                    BookOfShadowsGameModuleConfig.reelLockController.displayReelLockCosts(false);
                    BookOfShadows.setBoostedBet();
                }
            }
        }
    }

    private onFreeBets(startOfFreeBets: boolean) {
        //Should be noted that the start event is sent for each new freebet, not only the when the start dialog is closed.
        //The end event triggers when the end dialog is closed.
        //And it may trigger several times during startup if there is freebets.

        //You can also ask if it's freebets if you need to, like this:

        //BookOfShadows.api.freeBets.hasFreeBets()

        BookOfShadows.resetBoostedBet();

        // #291, #298, #301
        if (startOfFreeBets) {
            BookOfShadowsGameConfig.instance.ACTIVE_ROWS_ALLOWED_JURISDICTION = false;
            BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_VIA_BET = false;
        } else {
            BookOfShadowsGameConfig.instance.ACTIVE_ROWS_ALLOWED_JURISDICTION = this._activeRowsAllowedJurisdiction;
            BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_VIA_BET = false;
        }

        let rows = 3;
        if (startOfFreeBets) {
            if (this._restoreData){
                rows = this._restoreData.openRows;

                BookOfShadowsGameModuleConfig.inactiveRowController.updateVisibleRows(rows)
            } else {
                BookOfShadowsGameModuleConfig.inactiveRowController.updateVisibleRows(rows)
            }

        } else {
            BookOfShadowsGameModuleConfig.inactiveRowController.updateVisibleRows(rows)
            BookOfShadowsGameModuleConfig.inactiveRowController.onIdle();
        }
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M2",
                    "L5",
                    "L1",
                    "L3",
                    "M3",
                    "L4",
                    "S"
                ],
                [
                    "L2",
                    "S",
                    "L1",
                    "L3",
                    "L4",
                    "L2",
                    "M1"
                ],
                [
                    "L4",
                    "L2",
                    "M5",
                    "L5",
                    "L3",
                    "M1",
                    "L4"
                ],
                [
                    "M2",
                    "L2",
                    "M4",
                    "L3",
                    "L5",
                    "M3",
                    "M5"
                ],
                [
                    "L1",
                    "L5",
                    "M5",
                    "L3",
                    "L4",
                    "L1",
                    "M3"
                ]
            ],
            "evaluatedArea": [
                [
                    "L5",
                    "L1",
                    "L3",
                    "M3",
                    "L4"
                ],
                [
                    "S",
                    "L1",
                    "L3",
                    "L4",
                    "L2"
                ],
                [
                    "L2",
                    "M5",
                    "L5",
                    "L3",
                    "M1"
                ],
                [
                    "L2",
                    "M4",
                    "L3",
                    "L5",
                    "M3"
                ],
                [
                    "L5",
                    "M5",
                    "L3",
                    "L4",
                    "L1"
                ]
            ],
            "betLineWins": [],
            "scatterWins": [],
            "totalBetLineWins": 0,
            "totalScatterWins": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": -1, //At one point this value is compared to locally stored variable. If they match the reel locks won't reset. Therefore is this value set to -1 in order to never match locally stored value.
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "freespinPlayed": 0,
            "freespinsLeft": 0,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "addedNumberOfFreespinsThisSpin": 0,
            "fsSymbolPosition": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "fsSpecialSymbol": "",
            "playerSelection": -1,
            "playedRowsInFS": 3,
            "playedRowsInBase": 3,
            "fsNumberOfSpins": [
                10,
                8,
                6
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN_3_ROWS",
                    "type": "FREESPIN",
                    "price": 60
                },
                {
                    "name": "FREESPIN_4_ROWS",
                    "type": "FREESPIN",
                    "price": 90
                },
                {
                    "name": "FREESPIN_5_ROWS",
                    "type": "FREESPIN",
                    "price": 120
                },
                {
                    "name": "BOOSTED_BET_4_ROWS",
                    "type": "BOOSTED_BET_X_ROWS",
                    "price": 1.5
                },
                {
                    "name": "BOOSTED_BET_5_ROWS",
                    "type": "BOOSTED_BET_X_ROWS",
                    "price": 2
                },
                {
                    "name": "BOOSTED_BET_LOCKED_REELS",
                    "type": "BOOSTED_BET_LOCKED_REELS",
                    "price": 1
                }
            ],
            "featureBuyRows": -1,
            "featureBet": false,
            "wasFeatureBuy": false,
            "playerChoseRedrawSymbol": false,
            "previousFSSymbol": "",
            "gambleOptions": {},
            "gambledIntoBonus": false,
            "gambleModeChosen": -1,
            "gambleOptionPicked": -1,
            "gambleSuccess": false,
            "gambleCollect": false,
            "playerActions": {},
            "lockedReelDetails": [],
            "numberOfGamblesAllowed": 5,
            "maxGambleExposure": 25000,
            "numberOfGamblesDone": 0,
            "allowLockedReelsNextSpin": false,
            "allowLockedReelsThisSpin": false,
            "lockedReelsSet": ""
        };
    }
}